import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { TableCell, TableRow, TableBody, useMediaQuery, TableHead, Table, Paper, TableContainer, TextField, IconButton, Typography, MenuItem, Button, Box, Checkbox, Dialog, DialogTitle, DialogActions, DialogContent } from "@mui/material";
import Grid from '@mui/material/Grid'
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import { pad } from "../../functions/default";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import openFile from "../shared/functions/download";
import { useTheme } from '@mui/material/styles';
import UploadComponent from '../shared/components/UploadComponent';
//import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
function Dokumentenarchiv(props) {
  const { t } = useTranslation();
  const { accessToken, client } = props;
  const [showModal, setShowModal] = useState(false);//Pop-up Fenster bei Speicherung
  const [filterSettings, setFilterSettings] = useState(false);//Pop-up Fenster bei Speicherung
  const [showModalLOE, setShowModalLOE] = useState(false);//Pop-up Fenster bei Löschung
  const [isLoading, setIsLoading] = useState(false);//True=ladescreen
  const [ordner, setOrdner] = useState([]);//Array mit ordnern
  const [register, setRegister] = useState([]);//Array mit register
  const [dateienHilfe, setDateienHilfe] = useState(t("Wählen Sie einen Ordner + Register aus."));//Anzeige wenn kein Register ausgewählt ist
  const [aktuelles_Register, setAktuelles_Register] = useState("");//Momentan ausgewähltes Register
  const [filterRegister, setFilterRegister] = useState("");//Momentan ausgewähltes Register
  const [aktueller_Ordner, setAktueller_Ordner] = useState("");//Momentan ausgewählter Ordner
  const [datum,] = useState(new Date().getFullYear().toString() + '-' + pad(new Date().getMonth() + 1, 2) + '-' + pad(new Date().getDate(), 2));
  const navigate = useNavigate();
  const [suchWort, setSuchWort] = useState("");//Hilfs Variable für Suchleiste
  const [dateien, setDateien] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [ListeDateien, setListeDateien] = useState([]);//Hilfs Variable für Suchleiste
  const [selectedFile, setSelectedFile] = useState(null);//Variable für Datei download  
  const [position, setPosition] = useState('middle');
  const [personenNamen, setPersonenNamen] = useState('');
  const [personenID, setPersonenID] = useState('');
  const [auswahl, setAuswahl] = useState('')
  const [datumAuswaehlen, setDatumAuswaehlen] = useState("");
  const [selectDate, setSelectDate] = useState(false);
  const [uploadRegister, setUploadRegister] = useState('');
  const [paths, setPaths] = useState([]);
  const { hideMessage, showSuccessMessage, showErrorMessage } = useMessage();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setIsLoading(true);
    ordner_register_holen();
    // eslint-disable-next-line
  }, []);
  const dateiOeffnen = (docnr, name, endung, grund) => {
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "WEBDMS",
      "statement": "REACT_DMS",
      "grund": "oeffnen",
      "docnr": docnr,
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName = name +endung;
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(fileName, contentFile, mimeType);        
      })
      .catch(function (error) {
        showErrorMessage(error)      
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const dateiLoeschen = (docnummern) => {
    setShowModalLOE(false)
    setIsLoading(true)
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "WEBDMS",
      "docnr": docnummern,
      "statement": "REACT_DMS",
      "grund": "loeschen",
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, loeschen, setRedirect);
  }
  const loeschen = (response) => {
    setIsLoading(false);
    setAuswahl('')
    if (response.status === 200) {
      if (response.data.message === "OK") {
        showSuccessMessage(t("Löschung erfolgreich!"))
      } else {
        showErrorMessage(response.data.message)
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
    ordner_register_holen(aktueller_Ordner, aktuelles_Register)
  }
  const ordner_register_holen = (ordner, register) => {
    setIsLoading(true)
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "WEBDMS",
      "statement": "REACT_DMS",
      "grund": "laden",
      "aktueller_Ordner": ordner,
      "aktuelles_Register": register,
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, laden, setRedirect);
  }
  const setRedirect = (path) => {
    navigate(path);
  }
  const dateiAuswaehlen = (value, docnr) => {
    let zwis = ""
    if (value === true) {
      zwis = auswahl
      zwis += docnr + ";"
      setAuswahl(zwis)
    } else {
      zwis = auswahl
      zwis = zwis.replace(docnr + ";", "")
      setAuswahl(zwis)
    }
    zwis = ""
  }
  const laden = (response) => {
    setIsLoading(false);
    setAuswahl('')
    if (response.status === 200) {
      setPaths(response.data.paths)
      let ordner = [""]
      let ergebnis = [];
      for (let i = 0; i < response.data.ordner.length; i++) {
        ordner.push(response.data.ordner[i].name.toUpperCase())
      }
      let reihenfolge = ordner.sort()
      for (let a = 1; a < reihenfolge.length; a++) {
        for (let i = 0; i < response.data.ordner.length; i++) {
          if (response.data.ordner[i].name.toUpperCase().includes(reihenfolge[a])) {
            ergebnis.push(response.data.ordner[i])
          }
        }
      }
      setOrdner(ergebnis)
      setAktueller_Ordner(response.data.aktueller_Ordner)
      setAktuelles_Register(response.data.aktuelles_Register)
      setUploadRegister(response.data.aktuelles_Register)
      setDateien(response.data.dateien)
      setListeDateien(response.data.dateien)
      setRegister(response.data.registerA)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const closeModal = () => {
    setShowModal(false)
    setShowModalLOE(false)
    setSelectedFile(null)
    setPersonenID("")
    setPersonenNamen("")
    setShare("")
  }
  const allesSuchen = (SUCHE) => {
    if (aktueller_Ordner === "") {
      setFilterRegister("")
    }
    setAktueller_Ordner("")
    setAktuelles_Register("")
    setSuchWort(SUCHE)
    setIsLoading(true)
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "WEBDMS",
      "statement": "REACT_DMS",
      "grund": "suchen",
      "SUCHWOERTER": SUCHE,
      "register": filterRegister,
      "ordner": aktueller_Ordner,
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, suche, setRedirect);
  }
  const suche = (response) => {
    setAuswahl('')
    setIsLoading(false);
    if (response.status === 200) {
      setDateien(response.data.dateien)
      setSuchWort('')
      setDateienHilfe("Keine Dateien gefunden")
      setAktueller_Ordner(response.data.aktueller_Ordner)
      setAktuelles_Register(response.data.aktuelles_Register)
      setListeDateien(response.data.dateien)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const loadFiles = (ordner, register) => {
    setAktuelles_Register(register)
    setAktueller_Ordner(ordner)
    setIsLoading(true)
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "WEBDMS",
      "statement": "REACT_DMS",
      "grund": "loadFiles",
      "aktuelles_Register": register,
      "aktueller_Ordner": ordner,
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, files, setRedirect);
  }
  const files = (response) => {
    setIsLoading(false);
    setSuchWort("")
    if (response.status === 200) {
      setDateienHilfe("Keine Dateien gefunden")
      setAktueller_Ordner(response.data.aktueller_Ordner)
      setAktuelles_Register(response.data.aktuelles_Register)
      setUploadRegister(response.data.aktuelles_Register)
      setDateien(response.data.dateien)
      setListeDateien(response.data.dateien)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function filtern(eingabe, ort, liste, grund) {
    eingabe = eingabe.toUpperCase();
    let ergebnis = [];
    let d = ""
    for (let i = 0; i < ort.length; i++) {
      if (grund === "01") {
        d = ort[i].title;
      }
      if (grund === "02") {
        d = ort[i].ordner;
      }
      if (grund === "03") {
        d = ort[i].endung
      }
      d = d.toUpperCase();
      if (d.includes(eingabe)) {
        ergebnis.push(ort[i]);
      }
    }
    if (liste === 1) {
      setListeDateien(ergebnis)
    }
  }
  const onClickHandler = () => {
    console.log(selectedFile)
    if (isSending) return;
    if (!selectedFile) {
      showErrorMessage(t("Keine Datei ausgewählt"));
      return
    }
    if (selectedFile.length === 0) {
      showErrorMessage(t("Keine Datei ausgwählt"))
      return
    }
    if (!uploadRegister) {
      showErrorMessage(t("Kein Register ausgewählt"))
      return
    }
    if (personenID) {
      if (selectDate === true) {
        if (!datumAuswaehlen) {
          showErrorMessage(t("Kein Datum ausgewählt"))
          return
        }
      }
    }
    const data = new FormData();
    hideMessage()
    setIsLoading(true)
    setIsSending(true);
    let datumBis = (datumAuswaehlen.replace(/-/g, ""))
    console.log(selectedFile)
    for (let index = 0; index < selectedFile.length; index++) {
      data.append('file', selectedFile[index]);
    }
    console.log(data)
    console.log(selectedFile)
    // const headers={
    //     "Authorization": "Bearer "+accessToken,
    //     "Register": uploadRegister,
    //     "FileName": selectedFile,
    //     "date":datumBis,
    //     "share":datumBis,
    //     "teilen":personenID,
    //     "Mandant": client, // this.props.client,
    //     "Program": "CWARCH",
    //     "Statement": "DATEI_IN_DMS_ABLEGEN"
    // }
    // apiRequest('POST', 'upload', data, headers, dataCb);    
  }
  const dataCb = (response) => {
    setIsSending(false);
    setIsLoading(false);
    setShowModal(false);
    setSelectDate(false)
    setAuswahl('')
    if (response.status === 200) {
      setIsSending(false);
      setIsLoading(false);
      setSelectedFile(null)
      setUploadRegister("")
      setAktuelles_Register("")
      setAktueller_Ordner("")
      setListeDateien([])
      console.log(response.data.message_debug)
      if (response.data.message === 'ok') {
        showSuccessMessage(t("Upload erfolgreich."));
      } else {
        showErrorMessage(response.data.message)
      }
    } else {
      setIsSending(false);
      setIsLoading(false);
      if (response) {
        showErrorMessage(response.data.message);
        console.log(response.data.message_debug)
        setIsSending(false);
        setIsLoading(false);
      } else {
        showErrorMessage(t("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut."));
        setIsSending(false);
        setIsLoading(false);
      }
    }
    setIsSending(false);
    setIsLoading(false);
  }
  const displayPaths = (paths !== undefined) ? paths.map((dataObject, count) => {
    return (
      <MenuItem key={dataObject.key} value={dataObject.key}>
        {dataObject.ordBEZ} / {dataObject.bez}
      </MenuItem>
    );
  })
    :
    <MenuItem >
      {t("Keine Upload Register gefunden")}
    </MenuItem>
    ;
  const openLoeschDialoge = (docnr, name) => {
    setShowModalLOE(true)
  }
  const Dokumente = (ListeDateien !== undefined) ? ListeDateien.map((dataObject, count) => {
    if (!small) {
      return (
        <TableRow >
          <TableCell component="th" scope="row" item xs={2} color="textSecondary">
            <Typography color="textSecondary" variant="body1">{dataObject.ordner}</Typography>
          </TableCell>
          <TableCell hover style={{ cursor: 'pointer' }} onClick={() => dateiOeffnen(dataObject.docnr, dataObject.title, dataObject.endung, "oeffnen")} component="th" scope="row" item xs={2} color="textSecondary">
            <Typography hover color="textSecondary" variant="body1">{dataObject.title} </Typography>
          </TableCell>
          <TableCell component="th" scope="row" item xs={2} color="textSecondary">
            <Typography color="textSecondary" variant="body1">{dataObject.endung}</Typography>
          </TableCell>
          <TableCell component="th" scope="row" item xs={2} color="textSecondary">
            <Typography color="textSecondary" variant="body1">{dataObject.AENDdatum.substring(6, 8)}.{dataObject.AENDdatum.substring(4, 6)}.{dataObject.AENDdatum.substring(0, 4)}</Typography>
          </TableCell>
          <TableCell component="th" scope="row" item xs={2} color="textSecondary">
            <Tooltip title={t("Datei öffnen")}>
              <IconButton
                key={dataObject.docnr + "O"}
                onClick={(event) => dateiOeffnen(dataObject.docnr, dataObject.title, dataObject.endung, "oeffnen")}
                color="primary" aria-label="" >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
          <TableCell component="th" scope="row" item xs={2} color="textSecondary">
            <Checkbox
              checked={auswahl.includes(dataObject.docnr)}
              key={dataObject.docnr + "C"}
              onChange={(event) => dateiAuswaehlen(event.target.checked, dataObject.docnr)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </TableCell>
        </TableRow>
      );
    } else {
      return (
        <TableRow>
          <TableCell hover style={{ cursor: 'pointer' }} onClick={() => dateiOeffnen(dataObject.docnr, dataObject.title, dataObject.endung, "oeffnen")} component="th" size="small" scope="row" item color="textSecondary">
            <Typography color="textSecondary" variant="body2" >{dataObject.title}  </Typography>
            <Typography color="textSecondary" variant="body2" >{dataObject.AENDdatum.substring(6, 8)}.{dataObject.AENDdatum.substring(4, 6)}.{dataObject.AENDdatum.substring(0, 4)}</Typography>
            <Tooltip title={t("Datei öffnen")} align="center">
              <IconButton align="center"
              // onClick={(event) => dateiOeffnen(dataObject.docnr, dataObject.title, dataObject.endung, "oeffnen")}
                color="primary" aria-label="" >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    }
  })
    :
    <Typography variant="body1">{dateienHilfe}</Typography>
    ;
  const sortDate = (sort, pfeil) => {
    let merkdates = ""
    let dates = [""]
    let ergebnis = [];
    if (dateien === undefined) { return }
    setPosition(pfeil)
    if (sort === "alt") {
      for (let i = 0; i < dateien.length; i++) {
        if (merkdates.includes(dateien[i].AENDdatum) === false) {
          dates.push([dateien[i].AENDdatum])
          merkdates += dateien[i].AENDdatum + ";"
        }
      }
      let reihenfolge = dates.sort()
      for (let a = 1; a < reihenfolge.length; a++) {
        for (let i = 0; i < dateien.length; i++) {
          if (dateien[i].AENDdatum.includes(reihenfolge[a])) {
            ergebnis.push(dateien[i])
          }
        }
      }
      setListeDateien(ergebnis)
    }
    if (sort === "neu") {
      for (let i = 0; i < dateien.length; i++) {
        if (merkdates.includes(dateien[i].AENDdatum) === false) {
          dates.push([dateien[i].AENDdatum])
          merkdates += dateien[i].AENDdatum + ";"
        }
      }
      let reihenfolge = dates.sort()
      reihenfolge = reihenfolge.reverse()
      for (let a = 0; a < reihenfolge.length - 1; a++) {
        for (let i = 0; i < dateien.length; i++) {
          if (dateien[i].AENDdatum.includes(reihenfolge[a])) {
            ergebnis.push(dateien[i])
          }
        }
      }
      setListeDateien(ergebnis)
    }
    if (sort === "0") {
      setListeDateien(dateien)
    }
  }
  const Arrow = (pfeil) => {
    if (pfeil === "middle") {
      return (
        <IconButton style={{ marginTop: "30px" }} aria-label="delete" size="small"
          onClick={(event) => sortDate("neu", "down")}>
          <Typography>{t("Nach Datum sortieren")}</Typography>
          <ArrowForwardIosIcon style={{ color: "primary", marginTop: "" }} fontSize="inherit" />
        </IconButton>
      );
    }
    if (pfeil === "down") {
      return (
        <IconButton style={{ marginTop: "30px" }} aria-label="delete" size="small"
          onClick={(event) => sortDate("alt", "up")}>
          <Typography>{t("Nach Datum sortieren")}</Typography>
          <ArrowDownwardIcon style={{ color: "primary" }} fontSize="inherit" />
        </IconButton>
      );
    }
    if (pfeil === "up") {
      return (
        <IconButton style={{ marginTop: "30px" }} aria-label="delete" size="small"
          onClick={(event) => sortDate("0", "middle")}>
          <Typography>{t("Nach Datum sortieren")}</Typography>
          <ArrowUpwardIcon style={{ color: "primary" }} fontSize="inherit" />
        </IconButton>
      );
    }
  }
  const pruefeDatum = (wert) => {
    if (wert < datum) {
      showErrorMessage(t("Bitte Datum in der Zukunft auswählen"))
    } else {
      setDatumAuswaehlen(wert)
    }
  }
  const register_auswahl = (register !== undefined) ? register.filter((obj) => obj.ord === aktueller_Ordner).map((dataObject) => {
    return (
      <MenuItem key={dataObject.key} value={dataObject.key}>
        {dataObject.bez}
      </MenuItem>
    );
  })
    :
    <MenuItem key={"null"} value={"Kein"}>{t("Keine Dateien gefunden")}</MenuItem>
    ;
  const ordner_auswahl = (ordner?.length > 0) ? ordner.map((dataObject, count) => {
    return (
      <MenuItem color="primary" key={count} value={dataObject.key}>
        {dataObject.name}
      </MenuItem>
    );
  })
    :
    <MenuItem key={"null"} value={"Kein"}>{t("Keine Dateien gefunden")}</MenuItem>
    ;
  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <Page>
      <Layout fullWidth>
        <Box pt={1} pb={1}>
          <Button variant="contained" color="primary" onClick={() => { setShowModal(true) }}>{t("Datei hochladen")}</Button>
        </Box>
      </Layout>
      <Layout fullWidth>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Box p={2} pb={0}>
              <TextField
                fullWidth
                color="secondary"
                label={t("Über alles suchen")}
                defaultValue={suchWort}
                id="suchFeld"
                variant="outlined"
                onKeyUp={(event) => {
                  if (event.key === 'Enter') {
                    allesSuchen(event.target.value)
                  }
                }}
              />
            </Box>
            {small &&
              <Box pt={2}>
                <Button variant="contained" color="primary" onClick={() => allesSuchen(document.getElementById("suchFeld").value)}>{t("Suche starten")}</Button>
                <Button
                  startIcon={<SettingsIcon />}
                  onClick={(event) => setFilterSettings(true)}>
                  {t("Filter einstellungen setzen")}
                </Button>
              </Box>
            }
          </Grid>
          {!small &&
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Box p={2} pb={0}>
                  <TextField
                    fullWidth
                    select
                    color="secondary"
                    label={t("Ordner")}
                    value={aktueller_Ordner}
                    variant="outlined"
                    onChange={(event) => setAktueller_Ordner(event.target.value)}
                  >
                    {ordner_auswahl}
                  </TextField>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box p={2} >
                  <TextField
                    fullWidth
                    color="secondary"
                    select
                    value={aktuelles_Register}
                    label={t("Registerauswahl")}
                    variant="outlined"
                    onChange={(event => loadFiles(aktueller_Ordner, event.target.value))}
                  //onChange={(event) =>ladeListe(aktueller_Ordner,event.target.value)}
                  >
                    {register_auswahl}
                  </TextField>
                </Box>
              </Grid>
            </>
          }</Grid>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              {!small &&
                <TableRow>
                  <TableCell>
                    <TextField
                      color="primary"
                      label={t("Ordner")}
                      onChange={(event) => filtern(event.target.value, dateien, 1, "02")}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      color="primary"
                      label={t("Dateiname")}
                      onChange={(event) => filtern(event.target.value, dateien, 1, "01")}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      color="primary"
                      label={t("Endung")}
                      onChange={(event) => filtern(event.target.value, dateien, 1, "03")}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="body1" style={{ display: "inline-block", marginTop: "30px" }}></Typography>
                    {Arrow(position)}
                  </TableCell>
                  <TableCell>
                  </TableCell>
                  <TableCell>
                    {auswahl && //Mülleimer in Tabellenkopf anzeigen wenn mindestens eine Datei ausgewählt ist
                      <Tooltip title={t("Datei verwalten")}>
                        <IconButton
                          style={{ marginTop: "30px" }}
                          onClick={(event) => openLoeschDialoge()}
                          color="primary" aria-label="" >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  </TableCell>
                </TableRow>}
              {small &&
                <TableRow>
                  <TableCell>
                    <TextField
                      color="primary"
                      label={t("In Ergebnissen Suchen")}
                      fullWidth
                      variant="outlined"
                      onChange={(event) => filtern(event.target.value, dateien, 1, "01")}
                    />
                    {Arrow(position)}
                  </TableCell>
                </TableRow>}
            </TableHead>
            <TableBody>
              {Dokumente}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={showModal}
          maxWidth="md"
          fullWidth
        >
          <DialogContent>
            <UploadComponent accessToken={accessToken} auswahlRegister={aktuelles_Register} auswahlOrdner={aktueller_Ordner} client={client} program="WEBDMS" setIsLoading={setIsLoading} showSuccessMessage={showSuccessMessage} setShowModal={setShowModal} ordner={ordner} register={register} />
          </DialogContent>
          <DialogActions>
            <Button
              style={{ marginRight: "10px" }}
              color="primary"
              variant="contained"
              display="flex"
              onClick={() => { setShowModal(false); setSelectedFile(null); setShare(""); setPersonenID(""); setPersonenNamen("") }}>
              {t("Abbrechen")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dialog um Filter einstellungen zu setzen */}
        <Dialog
          open={filterSettings}
          fullWidth
        >
          <DialogContent>
            <Box p={2} pb={0}>
              <TextField
                fullWidth
                select
                color="secondary"
                label={t("Ordner")}
                value={aktueller_Ordner}
                variant="outlined"
                onChange={(event) => setAktueller_Ordner(event.target.value)}
              //onChange={(event)=>ladeListe(event.target.value,"")}
              >
                <MenuItem key={"alle"} value={""}>
                  {t("Alle Ordner")}
                </MenuItem>
                {ordner_auswahl}
              </TextField>
            </Box>
            <Box p={2} >
              <TextField
                fullWidth
                color="secondary"
                select
                defaultValue={filterRegister}
                label={t("Registerauswahl")}
                variant="outlined"
                onChange={(event) => setFilterRegister(event.target.value)}
              //onChange={(event) =>ladeListe(aktueller_Ordner,event.target.value)}
              >
                <MenuItem key={"alle"} value={""}>
                  {t("Alle Register")}
                </MenuItem>
                {register_auswahl}
              </TextField>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ marginRight: "10px" }}
              color="primary"
              variant="contained"
              display="flex"
              onClick={() => setFilterSettings(false)}>
              {t("Zurück")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={showModalLOE}
          setOpen={closeModal}
          fullWidth>
          <DialogTitle id="responsive-dialog-title">
            {"Sind Sie sicher dass sie die Datei löschen möchten?"}
          </DialogTitle>
          <DialogActions>
            <Button
              style={{ marginRight: "10px" }}
              color="primary"
              variant="contained"
              display="flex"
              onClick={() => setShowModalLOE(false)}>
              {t("Abbrechen")}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => dateiLoeschen(auswahl)}>
              {t("Bestätigen")}
            </Button>
          </DialogActions>
        </Dialog>
      </Layout>
    </Page>
  );
}
export default Dokumentenarchiv;
